
export const JOBS_BOOKMARKS_GET              = "JOBS_BOOKMARKS_GET"
export const JOBS_BOOKMARKS_SET              = "JOBS_BOOKMARKS_SET"